import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal, NumberInput } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faGem, faPlus, faRefresh, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { calculateTotal, funCheckNumber } from "../../Utility/utility"
import { Box, } from "@mui/material"
import { setRedirectLink } from "../../state/accountSlice"


const CreateReturnEntry = () => {
    const { compCode, isMultipleCompany, compState, startDate, endDate } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.memoEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const { btype, trdtype, ptype } = useParams();
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [modSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("")
    const [selBillType, setSelBillType] = useState("")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [naviCode, setnaviCode] = useState("")
    const [mixStockParams, setMixStockParams] = useState("")
    const [isRefId, setIsRefId] = useState(false)
    const [CurrencySetting, setCurrencySetting] = useState("")
    const dispatch = useDispatch();
    const gridContainerRef = useRef(null)
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)

    const minAllowedDate = dayjs(startDate)
    const maxAllowedDate = dayjs(endDate)
    const onSuccessMastData = (data) => {
        if (data && Object.keys(data).length > 0) {
            if (isNewEntry) {
                if (data.bookMaster.length > 0) {
                    setFormData({ ...formData, [formField.bookId]: data.bookMaster[0].Party_Id })
                    funGenVouNo(data.bookMaster[0].Party_Id)
                }
            }
        }
    }
    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMatserData } = usePost({
        url: apiRoute.memoEntry.entryMasterData,
        queryKey: "fetchMemoMasterData",
        onSuccessTasks: onSuccessMastData

    })
    const onSuccessChkPktLotNo = (data) => {

        if (data && data.length > 0) {
            // let total_pkt = data[0].count
            //let total_lot = data[1].count
            if (data[0].count > 0) {
                const newRows = [...rows]
                let msg = ""

                if (!toast.isActive('toats_chkpktlot')) {
                    toast.error("Duplicate Pkt No And Lot No Not Allow", {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toats_chkpktlot",


                    })
                }
                setRows(newRows)
            }
        }
    }
    const { data: dupLotPktNo = [], mutate: funChkPktLotNo } = usePost({
        url: apiRoute.memoEntry.checkLotPktNo,
        queryKey: "checkLotNoPktData",
        onSuccessTasks: onSuccessChkPktLotNo

    })
    const { data: dupCertitNo = [], mutate: funChkReportNo } = usePost({
        url: apiRoute.memoEntry.checkReportNo,
        queryKey: "checkReportNoData",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    let index = selectedGridRowId
                    const newRows = [...rows]
                    let msg = ""

                    if (!toast.isActive('toats_chkreportno')) {
                        toast.error("Duplicate ReportNo. Not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkreportno",


                        })
                    }
                    rows[index][RowsField.reportNo] = ""
                    setRows(newRows)
                }
            }
        }

    })
    const { data: mixStockData = [], mutate: filterMixStock } = usePost({
        url: apiRoute.memoEntry.fetchMixStock,
        queryKey: "fetchMixStockData",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                let index = selectedGridRowId
                if (data[0].weight > 0) {
                    const newRows = [...rows]

                    newRows[index][RowsField.pcs] = data[0].pcs
                    newRows[index][RowsField.weight] = data[0].weight
                    newRows[index][RowsField.oldPcs] = data[0].pcs
                    newRows[index][RowsField.oldWeight] = data[0].weight
                    setRows(newRows)
                    const newObject = Object.keys(mixStockParams).reduce((accumulator, key) => {
                        accumulator[key] = ''
                        return accumulator;
                    }, {});
                    setMixStockParams(newObject)

                }
                else {

                    if (!toast.isActive("toast_mixstock1")) {
                        const newRows = [...rows]

                        newRows[index][RowsField.pcs] = 0
                        newRows[index][RowsField.weight] = 0
                        setRows(newRows)
                        toast.error("Mix Stock Not Found", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toast_mixstock1"
                        })
                    }
                }
            }
            else {

                if (!toast.isActive("toast_mixstock")) {
                    toast.error("Stock Not Found", {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_mixstock"
                    })
                }
            }
        }

    })
    const { mutate: CheckMixStock } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.fetchMixStock,
        queryKey: "fetchcheckMixStockData",

    })
    const { data: stockData = [], mutate: filterStockData } = usePost({
        url: apiRoute.memoEntry.fetchStockData,
        queryKey: "fetchStockData",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {
                const newRows = [...rows]
                let index = selectedGridRowId
                newRows[index][RowsField.itemCode] = data[0].ItemCode
                newRows[index][RowsField.shapeCode] = data[0].ShapeCode
                newRows[index][RowsField.sizeCode] = data[0].SizeCode
                newRows[index][RowsField.colorCode] = data[0].ColorCode
                newRows[index][RowsField.purityCode] = data[0].PurityCode
                newRows[index][RowsField.reportNo] = data[0].ReportNo
                newRows[index][RowsField.lab] = data[0].Lab
                newRows[index][RowsField.lwRatio] = data[0].LwRatio
                newRows[index][RowsField.pcs] = data[0].BPcs
                newRows[index][RowsField.weight] = data[0].BWeight
                newRows[index][RowsField.sPktNo] = data[0].SPktNo
                newRows[index][RowsField.sLotNo] = data[0].SLotNo
                newRows[index][RowsField.pktNo] = data[0].PktNo
                newRows[index][RowsField.lotNo] = data[0].LotNo
                //const calData = funCalAllAmount(newRows, index, 0, 0, "")
                // newRows[index].amount = calData.amount
                // newRows[index].dAmount = calData.dAmount
                // if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
                //  newRows[index].rate = calData.rate
                setRows(newRows)
            }
            else {
                const newRows = [...rows]
                let index = selectedGridRowId
                newRows[index][RowsField.itemCode] = ""
                newRows[index][RowsField.shapeCode] = ""
                newRows[index][RowsField.sizeCode] = ""
                newRows[index][RowsField.colorCode] = ""
                newRows[index][RowsField.purityCode] = ""
                newRows[index][RowsField.reportNo] = ""
                newRows[index][RowsField.lab] = ""
                newRows[index][RowsField.lwRatio] = ""
                newRows[index][RowsField.pcs] = 0
                newRows[index][RowsField.weight] = 0
                newRows[index][RowsField.pktNo] = ""
                newRows[index][RowsField.lotNo] = ""
                setRows(newRows)
                if (!toast.isActive("toast_stock")) {
                    toast.error("Stock Not Found", {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_stock"
                    })
                }
            }
        }

    })
    const funGenVouNo = (bookid) => {
        if (bookid && bookid != "" && selBillType != "" && selTradeOf != "") {
            generateVouNo({
                data: {
                    comp_code: compCode.join(","),
                    vou_type: selBillType,
                    book_id: bookid,
                    trade_of: selTradeOf,

                }

            })
        }
    }
    const { isPending: isLoadingGridData, data: gridMasterData = [] } = useFetchWithBody({
        url: apiRoute.memoEntry.gridMasterData,
        queryKey: "fetchMemoGridMasterData",
    })
    const onSuccessVouno = (data) => {
        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.vouNo]: data[0]?.new_vou_no ?? '',
                [formField.challanNo]: data[0]?.new_vou_no ?? '',
            }))
        }
    }
    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.memoEntry.generateVoucherNo,
        queryKey: "generate-vouno",
        onSuccessTasks: onSuccessVouno
    })

    const onSuccessTasks = (data) => {
        navigate(funGetMasterLink());
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.memoEntry.add_update,
        queryKey: "funAddUpdateMemo",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.memoEntry.fetchEntryDetail,
        queryKey: "fetchMemoDetail",
    });

    const onSuccessChkChalNo = (data) => {

        if (data && data.length > 0) {
            setFormData({ ...formData, [formField.challanNo]: "" })
            toast.error("Memo No Exist Enter Another", {
                "position": "top-center",
                "className": "toast-error",
            })
        }
    }
    const { mutate: funchkChalNo } = usePost({
        url: apiRoute.memoEntry.checkChalNo,
        queryKey: "funcheck  Duplicate MemoNo",
        onSuccessTasks: onSuccessChkChalNo
    })

    const funGetDupChalNo = (book_id, chal_no) => {
        if (book_id != "" && chal_no != "") {
            funchkChalNo({
                data: {
                    compcode: compCode.join(","),
                    chal_no: chal_no,
                    book_id: book_id,
                    bill_type: selBillType
                }
            })
        }
    }
    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingInwardItem",
    })
    const funLoadMasterData = (tradeof, billtype,pkttype) => {
        filterMatserData({
            data: {
                compcode: compCode.join(","),
                tradeof: tradeof,
                billtype: billtype,
                pkttype:pkttype

            }
        })

    }

    const isSinglePacket = () => {
        if (ptype != "") {
            if (ptype == URIEncrypt.SinglePacket)
                return true
            else
                return false
        }
        else
            return false
    }
    let gridData = []
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
        if (!params.includes(String(trdtype)) || ![URIEncrypt.Sale, URIEncrypt.Purchase].includes(String(btype))
            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(ptype))
            navigate(linksUrl.dashboard.tradingDashboard)

        if (btype && btype != "" && trdtype && trdtype != "" && ptype && ptype != "") {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_billtype = ''
            let t_pktType = ''
            let t_btype = btype.toLowerCase()
            let t_trdtype = trdtype.toLowerCase()
            let modName = ''

            if (ptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'
            if (t_btype == URIEncrypt.Sale.toLowerCase()) {
                t_billtype = 'T'
            }
            else if (t_btype == URIEncrypt.Purchase.toLowerCase()) {
                t_billtype = 'N'
            }
            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish Diamond "
                if (t_billtype == 'T') { modName = isSinglePacket() ? ENUM_MOD_NAME.SalePolishMemoSingle : ENUM_MOD_NAME.SalePolishMemoMix }
                else if (t_billtype == 'N') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchasePolishMemoSingle : ENUM_MOD_NAME.PurchasePolishMemoMix }
                setnaviCode(t_billtype == 'T' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'N' ? linksUrl.purchaseEntry.roughDiamond : "")
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough Diamond "
                if (t_billtype == 'T') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRoughMemoSingle : ENUM_MOD_NAME.SaleRoughMemoMix }
                else if (t_billtype == 'N') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRoughMemoSingle : ENUM_MOD_NAME.PurchaseRoughMemoMix }
                setnaviCode(t_billtype == 'T' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'N' ? linksUrl.purchaseEntry.roughDiamond : "")
            }
            else if (t_trdtype == URIEncrypt.Rejection.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rejection
                t_entryLabel = "Rejection Diamond "
                if (t_billtype == 'T') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRejectionMemoSingle : ENUM_MOD_NAME.SaleRejectionMemoMix }
                else if (t_billtype == 'N') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRejectionMemoSingle : ENUM_MOD_NAME.PurchaseRejectionMemoMix }
                setnaviCode(t_billtype == 'T' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'N' ? linksUrl.purchaseEntry.roughDiamond : "")
            }

            setSelTradeOf(t_tradeof)
            setSelBillType(t_billtype)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)
            funLoadMasterData(t_tradeof, t_billtype,t_pktType)
            filterModSetting({
                data: {
                    page_mod: modName,
                    master_mod: ENUM_MOD_NAME.GeneralSettings
                }
            })
            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, transaction_id, bill_type, trade_of } = detailParams

                funGetDetail({
                    data: {
                        compcode: comp_code,
                        transactionid: transaction_id,
                        billtype: bill_type,
                        tradeof: trade_of
                    }
                })
            }
        }
    }, [btype, trdtype])


    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, generalData);
            setIsUseMfgNoAsMktno(mktSetting)
            setModSettingParams({
                Visibility: {
                    [RowsField.itemCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                },
                Value: {
                    [RowsField.itemCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,

                },
                Mandatory: {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    "allowNegativeStock": selBillType == 'N' ? getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.AllowNegativeStock, modData) ?? false : false,


                },
                MixStock: selTradeOf == "R" ? {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByItem, generalData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByLCode, generalData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockBySize, generalData) ?? false,
                } : {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByItem, generalData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLCode, generalData) ?? false,
                    [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByShape, generalData) ?? false,
                    [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByColor, generalData) ?? false,
                    [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByPurity, generalData) ?? false,
                    [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLwRatio, generalData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockBySize, generalData) ?? false,
                }


            })
        }

    }, [modSetting])

    useEffect(() => {
        if (modSettingParams && modSettingParams?.MixStock) {
            let array = Object.entries(modSettingParams?.MixStock).filter(([key, value]) => value == true).map(([key]) => { return { [key]: "" } })

            const result = array.reduce((acc, obj) => {
                return { ...acc, ...obj }
            }, {})
            if (mixStockParams == "")
                setMixStockParams(result)
        }
    }, [modSettingParams])

    const getLwRatioByShape = (shape) => {
        if (gridMasterData && Object.keys(gridMasterData).length > 0)
            return gridMasterData?.lwMaster.filter((ele) => ele.S_Code == shape)
        else
            return []
    }
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {
            gridData = detail?.itemDetail.map((item, i) => {
                return {
                    id: ++i,
                    itemCode: item?.Item_Code ?? "",
                    pcs: item?.Nos ?? 0,
                    weight: item?.Weight ?? 0,
                    rate: item?.Rate ?? 0,
                    amount: item?.Amount ?? 0,
                    detailId: item?.DetailId ?? 0,
                    lotNo: item?.L_Code ?? "",
                    pktNo: item?.PktNo ?? "",
                    sLotNo: item?.SL_Code ?? "",
                    sPktNo: item?.SPktNo ?? "",
                    lwRatio: item?.Lw_Code ?? "",
                    shapeCode: item?.S_Code ?? "",
                    colorCode: item?.Sh_Code ?? "",
                    purityCode: item?.Q_Code ?? "",
                    sizeCode: item?.Sz_Code ?? "",
                    reportNo: item?.ReportNo ?? "",
                    lab: item?.Lab ?? "",
                    oldWeight: item?.OldWeight ?? 0,
                    oldPcs: item?.OldPcs ?? 0,
                    bWeight: item?.BWeight ?? 0,
                    bPcs: item?.BPcs ?? 0,
                    refDetId: item?.RefDetId ?? 0,
                    retWeight: item?.Ret_Weight ?? 0,
                    invWeight: item?.Inv_Weight ?? 0,
                    dRate: item?.S_Rate ?? 0,
                    dAmount: item?.AmountD ?? 0,
                    convRate: item?.C_Rate ?? 0,
                    objLwRatio: getLwRatioByShape(item?.S_Code ?? "")
                }
            })
        }
    }

    const formField = {
        transId: "transId",
        vouNo: "vouNo",
        bookId: "bookId",
        partyId: "partyId",
        brokerId: "brokerId",
        challanNo: "challanNo",
        locationId: "locaionId",
        challanDate: "challanDate",
        tradeType: "tradeType",
        remark: "remark",
        pcs: "pcs",
        weight: "weight",
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.challanDate)
            acc[key] = dayjs(Date()).format("YYYY-MM-DD");
        else if (key == formField.netAmount || key == formField.pcs || key == formField.weight)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [rows, setRows] = useState([])

    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const total_Weight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )
    const net_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const total_RateD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dRate",
            }),
        [rows]
    )
    const total_Rate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_Pcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )
    const RowsField = {
        detailId: "detailId",
        id: "id",
        itemCode: "itemCode",
        itemName: "itemName",
        shapeName: "shapeName",
        shapeCode: "shapeCode",
        pktNo: "pktNo",
        lotNo: "lotNo",
        sPktNo: "sPktNo",
        sLotNo: "sLotNo",
        purityName: "purityName",
        purityCode: "purityCode",
        colorName: "colorName",
        colorCode: "colorCode",
        sizeName: "sizeName",
        sizeCode: "sizeCode",
        lwRatio: "lwRatio",
        objLwRatio: "objLwRatio",
        rate: "rate",
        amount: "amount",
        pcs: "pcs",
        weight: "weight",
        reportNo: "reportNo",
        lab: "lab",
        oldWeight: "oldWeight",
        oldPcs: "oldPcs",
        bPcs: "bPcs",
        bWeight: "bWeight",
        refDetId: "refDetId",
        convRate: "convRate",
        dRate: "dRate",
        dAmount: "dAmount",



    }
    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.shapeName]: "",
        [RowsField.shapeCode]: "",
        [RowsField.pktNo]: "",
        [RowsField.lotNo]: "",
        [RowsField.sPktNo]: "",
        [RowsField.sLotNo]: "",
        [RowsField.reportNo]: "",
        [RowsField.lab]: "",
        [RowsField.purityName]: "",
        [RowsField.purityCode]: "",
        [RowsField.colorName]: "",
        [RowsField.colorCode]: "",
        [RowsField.sizeName]: "",
        [RowsField.sizeCode]: "",
        [RowsField.lwRatio]: "",
        [RowsField.rate]: 0,
        [RowsField.amount]: 0,
        [RowsField.pcs]: 0,
        [RowsField.weight]: 0,
        [RowsField.oldWeight]: 0,
        [RowsField.oldPcs]: 0,
        [RowsField.bPcs]: 0,
        [RowsField.bWeight]: 0,
        [RowsField.refDetId]: 0,
        [RowsField.convRate]: 0,
        [RowsField.dRate]: 0,
        [RowsField.dAmount]: 0,
        [RowsField.objLwRatio]: []


    }

    const itemGridHeadClass = "bill-grid-style"
    const [formData, setFormData] = useState({
        ...emptyFormField
    })


    const inputBoxes = {
        Row1: [
            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Memo No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.bookId,
                name: formField.bookId,
                placeholder: "Book Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.bookMaster ? masterData?.bookMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,
            },

        ],

        Row2: [

            {
                id: formField.partyId,
                name: formField.partyId,
                placeholder: "Party Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.brokerId,
                name: formField.brokerId,
                placeholder: "Broker",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.brokerMaster ? masterData?.brokerMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },


        ],
        Row3: [
            {
                id: formField.challanNo,
                name: formField.challanNo,
                placeholder: "Challan No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.challanDate,
                name: formField.challanDate,
                placeholder: " Challan Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row4: [
            {
                id: formField.tradeType,
                name: formField.tradeType,
                placeholder: "Trade Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: ENUM_TRADE_TYPE,
                itemkey: "t_type",
                itemvalue: "t_type",
                isrequired: true,
            },
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },

        ],
        Row5: [
            {
                id: formField.remark,
                name: formField.remark,
                placeholder: "Remark.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ]

    }

    const funSetTradeType = (partyId) => {
        if (partyId != "" && partyId != null) {
            let t_tradeType = formData.tradeType

            if (compState && compState?.trim() != "") {
                const tempData = masterData.acMaster.filter((ele) => ele.Party_Id == partyId)

                if (tempData && tempData?.length > 0) {
                    if (tempData[0]?.ADD_6.trim() != "") {
                        if (tempData[0]?.ADD_6.trim().toLowerCase() == compState?.trim().toLowerCase())
                            t_tradeType = "RD"
                        else
                            t_tradeType = "OGS"
                    }
                    else
                        t_tradeType = "URD"
                }
                // if (t_tradeType == "URD" || t_tradeType == "RD") setIsStPerDisable(false)
                // else setIsStPerDisable(true)
            }
            return t_tradeType
        }
        else
            return ""
    }

    const hanldeBlur = (index, e) => {


        const { value, name, id } = e.target

        if (name == formField.challanNo) {
            funGetDupChalNo(formData[formField.bookId], value)
        }
        else if (id == RowsField.reportNo || id == RowsField.lotNo || id == RowsField.pktNo) {
            setSelectedGridRowId(index)
            const newRows = [...rows]

            let t_lotno = id == RowsField.lotNo ? value : newRows[index][RowsField.lotNo]
            let t_pktno = id == RowsField.pktNo ? value : newRows[index][RowsField.pktNo]
            let t_reportno = id == RowsField.reportNo ? value : newRows[index][RowsField.reportNo]
            let isDuplicate = 0;
            if (selPktType == 'SNG' && id == RowsField.reportNo && value != "") {

                const pktData = rows.filter((ele, i) => i != index && ele.reportNo.toLowerCase() == value.toLowerCase())

                if (pktData && pktData.length > 0) {
                    isDuplicate = 1
                    toast.error("Duplicate ReportNo. not allow", {
                        position: "top-center",
                        "className": "toast-error",
                    })
                    newRows[index][RowsField.reportNo] = ""
                    setRows(newRows)
                }
            }
            else if (selPktType == 'SNG' && t_lotno != "" && t_pktno != "") {
                const pktData = rows.filter((ele, i) => i != index && ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                if (pktData && pktData.length > 0) {
                    //  if (pktData[0].id != index + 1) {
                    isDuplicate = 1
                    toast.error("duplicate lot No and Pkt No. not allow", {
                        position: "top-center"
                    })
                    newRows[index][RowsField.lotNo] = ""
                    newRows[index][RowsField.pktNo] = ""
                    setRows(newRows)
                    // }
                }
            }
            if (!isDuplicate) {

                if (selBillType == 'T' && selPktType == 'SNG') {
                    if (id == RowsField.reportNo) {
                        const pktData = rows.filter((ele, i) => i == index && ele.detailId != 0 && ele.reportNo.toLowerCase() == t_reportno.toLowerCase())
                        //const pktData = rows.filter((ele, i) => i != index && ele.reportNo.toLowerCase() == value.toLowerCase())
                        if (pktData && pktData.length > 0) {
                            funChkReportNo({
                                data: {
                                    reportno: value
                                }
                            })
                        }
                    }
                    else if (id == RowsField.pktNo || id == RowsField.lotNo) {
                        const pktData = rows.filter((ele, i) => i == index && ele.detailId != 0 && ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                        //const pktData = rows.filter((ele, i) => i != index && ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                        if (pktData && pktData.length > 0) {
                            funChkPktLotNo({
                                data: {
                                    compcode: compCode.join(","),
                                    lotno: t_lotno,
                                    pktNo: t_pktno
                                }

                            })
                        }
                    }
                }
                else if (selBillType == 'N') {
                    if (selPktType == 'SNG') {
                        if (id == RowsField.reportNo && t_reportno != "") {
                            const pktData = rows.filter((ele, i) => i == index && ele.detailId != 0 && ele.reportNo.toLowerCase() == t_reportno.toLowerCase())
                            if (pktData && pktData.length <= 0) {
                                filterStockData({
                                    data: {
                                        compcode: compCode.join(","),
                                        reportno: t_reportno,
                                        tradeof: selTradeOf,
                                        action: 'Stock_By_ReportNo'
                                    }
                                })
                            }
                        }
                        else if (t_lotno != "" && t_pktno != "") {
                            const pktData = rows.filter((ele, i) => i == index && ele.detailId != 0 && ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                            if (pktData && pktData.length <= 0) {
                                filterStockData({
                                    data: {
                                        compcode: compCode.join(","),
                                        lotno: t_lotno,
                                        pktno: t_pktno,
                                        tradeof: selTradeOf
                                    }
                                })
                            }
                        }
                    }

                }
                if (mixStockParams.hasOwnProperty(id) && selPktType != "SNG")
                    funSetMixStockKeys(RowsField.lotNo, value)
            }

        }
        else if (id == RowsField.pcs || id == RowsField.weight) {
            const newRows = [...rows]

            let chkPcsValue = ""
            let chkWeightValue = ""
            if (selPktType == 'SNG' && selBillType == 'T' && Number(newRows[index][RowsField.detailId] > 0)) {
                chkPcsValue = newRows[index][RowsField.bPcs]
                chkWeightValue = newRows[index][RowsField.bWeight]

            }
            else if (selPktType == "MIX" && selBillType == 'N' && modSettingParams && !modSettingParams.Mandatory.allowNegativeStock) {
                chkPcsValue = newRows[index][RowsField.oldPcs]
                chkWeightValue = newRows[index][RowsField.oldWeight]

            }
            if (chkPcsValue != "" || chkWeightValue != "") {
                if (id == RowsField.pcs) {
                    if (Number(value) > Number(chkPcsValue)) {
                        toast.error(`Pcs should be less than (${chkPcsValue})`, {
                            "position": "top-center",
                            "className": "toast-error",
                        })
                        newRows[index][RowsField.pcs] = chkPcsValue
                    }

                }

                else if (id == RowsField.weight) {
                    if (parseFloat(value) > parseFloat(chkWeightValue)) {
                        toast.error(`Weight should be less than (${chkWeightValue})`, {
                            "position": "top-center",
                            "className": "toast-error",
                        })
                        newRows[index][RowsField.weight] = chkWeightValue
                    }

                }
                setRows(newRows)
            }

        }

    }

    const funSetMixStockKeys = (key, value) => {
        if (selPktType == 'MIX') {
            if (modSettingParams && modSettingParams?.MixStock) {
                if (mixStockParams.hasOwnProperty(key)) {
                    // const newObj = { ...mixStockParams, [key]: value }
                    let newRows = [...rows]
                    let index = selectedGridRowId ?? 0
                    const arr = Object.keys(mixStockParams).map((ele) => {
                        if (ele == key)
                            return { [ele]: value }
                        else
                            return { [ele]: newRows[index][ele] ?? "" }
                    })

                    const merged = Object.assign({}, ...arr);
                    const newObj = { ...merged }
                    const allKeysHaveValue = Object.values(newObj).every(value => value !== "" && value !== null && value !== undefined);
                    if (allKeysHaveValue) {
                        let duplicate = 0
                        // let index = selectedGridRowId ?? 0
                        const duplicateRows = rows.filter((item, i) => i !== index &&
                            Object.entries(newObj).every(
                                ([key, value]) => item[key] === value
                            )
                        );

                        if (duplicateRows && duplicateRows?.length > 0) {
                            duplicate = 1
                            toast.error("duplicate items not allow it already added", {
                                position: "top-center",
                                "className": "toast-error",
                            })
                            const newRows = [...rows]
                            let index = selectedGridRowId ?? 0
                            Object.keys(newObj).map((ele) => {
                                newRows[index][ele] = ""
                            })
                            setRows(newRows)
                        }
                        if (selBillType == 'N' && !duplicate) {
                            filterMixStock({
                                data: {
                                    compcode: compCode.join(","),
                                    itemcode: mixStockParams.hasOwnProperty(RowsField.itemCode) ? newObj[RowsField.itemCode] : null,
                                    lotno: mixStockParams.hasOwnProperty(RowsField.lotNo) ? newObj[RowsField.lotNo] : null,
                                    pktno: mixStockParams.hasOwnProperty(RowsField.pktNo) ? newObj[RowsField.pktNo] : null,
                                    scode: mixStockParams.hasOwnProperty(RowsField.shapeCode) ? newObj[RowsField.shapeCode] : null,
                                    shcode: mixStockParams.hasOwnProperty(RowsField.colorCode) ? newObj[RowsField.colorCode] : null,
                                    qcode: mixStockParams.hasOwnProperty(RowsField.purityCode) ? newObj[RowsField.purityCode] : null,
                                    szcode: mixStockParams.hasOwnProperty(RowsField.sizeCode) ? newObj[RowsField.sizeCode] : null,
                                    lwcode: mixStockParams.hasOwnProperty(RowsField.lwRatio) ? newObj[RowsField.lwRatio] : null,
                                    tradeof: selTradeOf
                                }
                            })
                        }
                    }
                    setMixStockParams(newObj)
                }
            }

        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    const handleAutoCompleteChange = (value, rowid, name) => {

        if (name == formField.partyId || name == formField.tradeType || name == formField.bookId || name == formField.brokerId || name == formField.locationId) {
            let t_tradeType = formData.tradeType
            if (name == formField.bookId) {
                funGetDupChalNo(value, formData[formField.challanNo])
                funGenVouNo(value)
            }
            else if (name == formField.partyId) {
                t_tradeType = funSetTradeType(value)
            }
            else if (name == formField.tradeType) {
                if (t_tradeType == "")
                    t_tradeType = value
            }
            setFormData({
                ...formData,
                [name]: value,
                [formField.tradeType]: t_tradeType

            })
        }

        else {

            if (name == RowsField.itemName && rows.find((ele) => ele.itemCode == value)) {
                addToast({
                    title: "",
                    description: "Item already added",
                    color: "danger"
                })
                const index = rows.findIndex((ele) => ele.id == rowid)
                let newRow = [...rows]
                newRow[index].itemCode = ""
                newRow[index].itemName = ""
                setRows(newRow)
            }
            else {

                let name_val = ""
                let tempData = []
                let findData = []
                let keyfield = ""
                const index = rows.findIndex((ele) => ele.id == rowid)
                setSelectedGridRowId(index)

                if (name == RowsField.itemName) {
                    keyfield = RowsField.itemCode
                    tempData = masterData.itemMaster
                    findData = tempData.filter((ele) => ele.Item_Code == value)
                    name_val = findData[0]?.Item_Desc ?? ''
                    funSetMixStockKeys(keyfield, value)

                }
                else if (name == RowsField.shapeName) {
                    keyfield = RowsField.shapeCode
                    tempData = gridMasterData.shapeMaster
                    findData = tempData.filter((ele) => ele.S_Code == value)
                    name_val = findData[0]?.S_Name ?? ''
                    funSetMixStockKeys(keyfield, value)
                }
                else if (name == RowsField.colorName) {
                    keyfield = RowsField.colorCode
                    tempData = gridMasterData.colorMaster
                    findData = tempData.filter((ele) => ele.Sh_Code == value)
                    name_val = findData[0]?.Sh_Name ?? ''
                    funSetMixStockKeys(keyfield, value)
                }
                else if (name == RowsField.purityName) {
                    keyfield = RowsField.purityCode
                    tempData = gridMasterData.purityMaster
                    findData = tempData.filter((ele) => ele.Q_Code == value)
                    name_val = findData[0]?.Q_Name ?? ''
                    funSetMixStockKeys(keyfield, value)
                }
                else if (name == RowsField.sizeName) {
                    keyfield = RowsField.sizeCode
                    tempData = gridMasterData.sizeMaster
                    findData = tempData.filter((ele) => ele.Sz_Code == value)
                    name_val = findData[0]?.Sz_Name ?? '' // +" " +findData[0].T_Size
                    funSetMixStockKeys(keyfield, value)
                }
                else if (name == RowsField.lwRatio) {
                    keyfield = RowsField.lwRatio
                    tempData = gridMasterData.lwMaster
                    name_val = value
                    findData = tempData.filter((ele) => ele.LwCode == value)
                    funSetMixStockKeys(keyfield, value)
                }

                let newRow = [...rows]

                if (findData && findData.length > 0) {
                    if (name == RowsField.shapeName) {
                        newRow[index][RowsField.objLwRatio] = getLwRatioByShape(value)
                    }
                    newRow[index][keyfield] = value
                    newRow[index][name] = name_val
                    setRows(newRow)
                }

            }
        }



    }
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        const rearrangedRows = updatedRows.map((row, index) => {
            if (row.id == 100)
                return row
            else
                return {
                    ...row,
                    id: index + 1
                } // Reassign IDs to start from 1 again
        })
        setRows(rearrangedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])
    }
    const funCalAllAmount = (rowData, index, pcs, weight, currentID) => {

        let newRows = [...rows]
        if (rowData && rowData.length > 0)
            newRows = [...rowData]
        let t_Amount = 0
        let t_DAmount = 0
        let tempVal = 0

        let t_rate = newRows[index].rate && newRows[index].rate != null ? newRows[index].rate : 0
        let t_DRate = newRows[index].dRate && newRows[index].dRate != null ? newRows[index].dRate : 0
        const t_pcs = pcs && pcs != null && pcs > 0 ? pcs : newRows[index].pcs ?? 0
        const t_weight = weight && weight != null && weight != "" && weight > 0 ? weight : newRows[index].weight ?? 0

        // tempVal = parseFloat(t_rate) * parseFloat(t_weight)

        let conv_rate = newRows[index].convRate && newRows[index].convRate != null ? newRows[index].convRate : 0
        if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
            // / && CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar
            if ((currentID == RowsField.dRate || currentID == RowsField.convRate)) {
                tempVal = parseFloat(t_DRate) * parseFloat(conv_rate)
                t_rate = funCheckNumber(tempVal).toFixed(2)
            }
            else if (currentID == RowsField.rate || currentID == RowsField.convRate) {
                tempVal = parseFloat(t_rate) / parseFloat(conv_rate)
                t_DRate = funCheckNumber(tempVal).toFixed(2)
            }
        }

        tempVal = parseFloat(t_rate) * parseFloat(t_weight)
        t_Amount = funCheckNumber(tempVal)
        tempVal = parseFloat(t_DRate) * parseFloat(t_weight)
        t_DAmount = funCheckNumber(tempVal)


        //t_Amount = funCheckNumber(tempVal)
        return {
            amount: t_Amount.toFixed(2), dAmount: t_DAmount.toFixed(2), dRate: t_DRate,
            rate: t_rate
        }
        // let t_Amount = 0
        // let tempVal = 0
        // let t_rate = newRows[index].rate && newRows[index].rate != null ? newRows[index].rate : 0
        // const t_pcs = pcs && pcs != null && pcs > 0 ? pcs : newRows[index].pcs ?? 0
        // const t_weight = weight && weight != null && weight != "" && weight > 0 ? weight : newRows[index].weight ?? 0

        // tempVal = parseFloat(t_rate) * parseFloat(t_weight)

        // t_Amount = funCheckNumber(tempVal)
        // return { amount: t_Amount.toFixed(2) }

    }
    //end delete row from dynamic grid
    const handleInputChange = (rowId, e, name) => {

        let { value, id } = e.target
        let index = rows.findIndex(ele => ele.id == rowId)
        const newRows = [...rows]
        setSelectedGridRowId(index)

        newRows[index][id] = value

        if (id == RowsField.rate ||
            id == RowsField.dRate ||
            id == RowsField.convRate ||
            id == RowsField.pcs ||
            id == RowsField.weight
        ) {

            const calData = funCalAllAmount(newRows, index, 0, 0, id)
            // newRows[index].amount = calData.amount
            newRows[index].amount = calData.amount
            newRows[index].dAmount = calData.dAmount

            // console.log(calData)
            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                if (id != RowsField.dRate)
                    newRows[index].dRate = calData.dRate //.toFixed(2)
                if (id != RowsField.rate)
                    newRows[index].rate = calData.rate //.toFixed(2)
            }
        }

        setRows(newRows)
    }
    const funIsFooter = (id) => {
        if (id == 100)
            return true
        else
            return false
    }
    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (

            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                type={input_type}
                size="sm"
                // label=""
                labelPlacement="outside"
                readOnly={is_readonly}
                disabled={is_readonly}
                placeholder={holder_text}
                //allow space in text box
                onBlur={(e) => hanldeBlur(row.id - 1, e)}
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                value={row[input_id]}
                onChange={(e) => handleInputChange(row.id, e, "")}
                className="max-w-xs mt-1"
                classNames={{
                    "input": `${input_type == "number" ? "text-right" : ""}  text-sm `,

                }}
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}

            ></Input>
        )
    }
    const setColumnRequired = (column) => {
        if (selPktType == "MIX" && mixStockParams && mixStockParams.hasOwnProperty(column))
            return true
        else if (modSettingParams && modSettingParams?.Mandatory) {
            return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false
        }
        else
            return false
    }
    const setColumnDisable = (row, column) => {
        if (!isRefId) {
            if (selBillType == 'N') {
                if (selPktType == 'SNG') {
                    return true
                }
                else
                    return false
            }
            else if (selBillType == 'T') {
                if (row.detailId > 0 && (row.retWeight > 0 || row.invWeight > 0)) {
                    return true
                }
                else {
                    if (isNewEntry)
                        return false
                    else if ([RowsField.dRate, RowsField.rate, RowsField.convRate].includes(column))
                        return false
                    else
                        return true
                }
                // if (selPktType == 'SNG' && row.detailId > 0 && (row.retWeight > 0 || row.invWeight > 0))
                //     return true
                // else
                //     return false
            }
        }
        return true
    }
    const setColumnVisiblity = (column) => {
        if (modSetting && Object.keys(modSetting).length > 0)
            return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
        else
            return true
    }
    const setNegativeStockEnable = () => {
        if (selPktType == "MIX" && modSettingParams) {
            if (modSettingParams.Mandatory.allowNegativeStock)
                return false

        }
    }
    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = [RowsField.rate, RowsField.amount]
        const DCol = [RowsField.dRate, RowsField.dAmount, RowsField.convRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }
    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-center"> Total</div> :
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>
                            <strong>

                                <FontAwesomeIcon
                                    color="red"
                                    className={`cursor-pointer`}
                                    onClick={() => handleDeleteRow(row.id)}
                                    icon={faSquareXmark}
                                ></FontAwesomeIcon>

                            </strong>
                        </div>}
                </div>
            ),
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>

                {funIsFooter(row.id) ? "" : row.itemCode}
            </div>)

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 300,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.itemCode)}
                            size="sm"
                            color={"danger"}
                            id={RowsField.itemName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23 text-xs"

                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingData}
                            isReadOnly={setColumnDisable(row, RowsField.itemCode)}
                            isVirtualized
                            defaultItems={
                                masterData && masterData.itemMaster ? masterData?.itemMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.itemName)
                            }
                            //onChange={handleFormSelectionChange}
                            selectedKey={row.itemCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Item_Code}
                                >
                                    {item.Item_Code + "(" + item.Item_Desc + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }

                </div>
            ),
        },
        {
            field: RowsField.reportNo,
            headerName: "Report No.",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.reportNo, "text",
                    selPktType == 'SNG' && selBillType == 'N' && !isRefId ? false
                        : selPktType == 'SNG' && selBillType == 'T' && !isNewEntry && row.detailId > 0 ? true :
                            isRefId ? true : false,
                    "", setColumnRequired(RowsField.reportNo), "", "")
                }</div>
            )
        },
        {
            field: RowsField.lotNo,
            headerName: "Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (

                <div>{funIsFooter(row.id) ? "" :
                    (renderInputCell(row, RowsField.lotNo, "text",
                        selPktType == 'SNG' && selBillType == 'N' && !isRefId ? false
                            : selPktType == 'SNG' && selBillType == 'T' && !isNewEntry && row.detailId > 0 ? true :
                                isRefId ? true : false,
                        "",
                        setColumnRequired(RowsField.lotNo)
                        , "", ""))
                }</div>

            ),
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{
                    funIsFooter(row.id) ? "" :
                        renderInputCell(row, RowsField.pktNo, "text",
                            selPktType == 'SNG' && selBillType == 'N' && !isRefId ? false :
                                selPktType == 'SNG' && selBillType == 'T' && !isNewEntry && row.detailId > 0 ? true :
                                    isRefId ? true : false,
                            ""
                            , setColumnRequired(RowsField.pktNo)
                            , "", "")
                }</div>
            )
        },
        {
            field: RowsField.shapeName,
            headerName: "Shape",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.shapeCode)}
                            size="sm"
                            color={"warning"}
                            id={RowsField.shapeName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isReadOnly={setColumnDisable(row, RowsField.shapeCode)}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.shapeMaster ? gridMasterData?.shapeMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.shapeName)
                            }
                            selectedKey={row.shapeCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.S_Code}
                                >
                                    {item.S_Code + "(" + item.S_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },

        {
            field: RowsField.colorName,
            headerName: "Color",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.colorCode)}
                            size="sm"
                            color={"success"}
                            id={RowsField.colorName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={setColumnDisable(row, RowsField.colorCode)}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.colorMaster ? gridMasterData?.colorMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.colorName)
                            }
                            selectedKey={row.colorCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Sh_Code}
                                >
                                    {item.Sh_Code + "(" + item.Sh_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>}


                </div>
            ),
        },

        {
            field: RowsField.purityName,
            headerName: "Purity",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.purityCode)}
                            size="sm"
                            color={"primary"}
                            id={RowsField.purityName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={setColumnDisable(row, RowsField.purityCode)}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.purityMaster ? gridMasterData?.purityMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.purityName)
                            }
                            selectedKey={row.purityCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Q_Code}
                                >
                                    {item.Q_Code + "(" + item.Q_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },

        {
            field: RowsField.sizeName,
            headerName: "Size",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.sizeCode)}
                            size="sm"
                            color={"default"}
                            id={RowsField.sizeName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={setColumnDisable(row, RowsField.sizeCode)}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.sizeMaster ? gridMasterData?.sizeMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.sizeName)
                            }
                            selectedKey={row.sizeCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Sz_Code}
                                >
                                    {item.Sz_Name}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },
        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {
                        // funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lwRatio, "text",
                        //     setColumnDisable(row, RowsField.lwRatio),
                        //     "", false, "", "")

                        funIsFooter(row.id) ? "" :
                            <Autocomplete
                                isRequired={setColumnRequired(RowsField.lwRatio)}
                                size="sm"
                                color={"warning"}
                                id={RowsField.lwRatio}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                placeholder="--Select--"
                                className="max-w-23"
                                menuTrigger={"input"}
                                isClearable={false}
                                isLoading={isLoadingGridData}
                                isReadOnly={setColumnDisable(row, RowsField.lwRatio)}
                                isVirtualized
                                defaultItems={
                                    row[RowsField.objLwRatio] ? row[RowsField.objLwRatio] : []
                                }
                                onSelectionChange={(e) =>
                                    handleAutoCompleteChange(e, row.id, RowsField.lwRatio)
                                }
                                selectedKey={row.lwRatio}
                            >
                                {(item) => (
                                    <AutocompleteItem
                                        key={item.LwCode}
                                    >
                                        {item.LwCode}
                                        {/* {item.F_Lnth + " " + item.T_Lnth} */}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                    }</div>
            )
        },
        // {
        //     field: RowsField.lwRatio,
        //     headerName: "LxW Ratio",
        //     minWidth: 120,
        //     flex: 1,
        //     headerAlign: "center",
        //     headerClassName: itemGridHeadClass,
        //     renderCell: ({ row }) => (
        //         <div>
        //             {
        //                 funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lwRatio, "text",
        //                     setColumnDisable(row,RowsField.lwRatio),
        //                     "", false, "", "")
        //             }</div>
        //     )
        // },

        {
            field: RowsField.lab,
            headerName: "Lab",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lab, "text",
                    setColumnDisable(row, RowsField.lab),
                    "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            minWidth: 70,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_Pcs}</div> :
                    renderInputCell(row, RowsField.pcs, "number",
                        setColumnDisable(row, RowsField.pcs),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_Weight}</div>
                    : renderInputCell(row, RowsField.weight, "number",
                        setColumnDisable(row, RowsField.weight),
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.dRate,
            headerName: "Out Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_RateD}</div> :
                renderInputCell(row, RowsField.dRate, "number",
                    setColumnDisable(row, RowsField.dRate),
                    // CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? setColumnDisable(row) : true,
                    "", true, "", "")
            }</div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Out Amount($)",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{net_AmountD}</div> : row[RowsField.dAmount]
                    }
                </div>)
        },
        {
            field: RowsField.convRate,
            headerName: "conv.Rate",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" ></div> :
                    renderInputCell(row, RowsField.convRate, "number",
                        setColumnDisable(row, RowsField.convRate),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_Rate}</div> :
                renderInputCell(row, RowsField.rate, "number",
                    //  CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? setColumnDisable(row,RowsField.rate) : true,
                    setColumnDisable(row, RowsField.rate),
                    "", true, "", "")
            }</div>
            )
        },

        {
            field: RowsField.amount,
            headerName: "Amount",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{net_Amount}</div> : row[RowsField.amount]
                    }
                </div>)
        },


    ]
    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.vouNo] = "Memo No required"
        }

        if (formData[formField.partyId] == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Party Name required"
        }
        if (formData[formField.bookId] == "" || formData[formField.bookId] == "0") {
            newErrors[formField.bookId] = "Book Name required"
        }

        if (formData.challanNo.trim() == "") {
            newErrors[formField.challanNo] = "Challan No required"
        }
        if (formData[formField.challanDate] == null || formData[formField.challanDate] == "" || formData[formField.challanDate] == "Invalid Date") {
            newErrors[formField.challanDate] = "Challan Date required"
        }



        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            const d = rows.filter(ele => ele.id != 100)
            if (d.length > 0) {
                for (let i = 0; i < d.length; i++) {
                    if (d[i].id != 100) {
                        if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                            if (d[i].convRate == "" || d[i].convRate == "0") {
                                if (!msg.includes("Conv. Rate"))
                                    msg = msg + "  Conv. Rate ,";
                                no = 1
                            }
                        }
                    }
                }
            }
            else {

                msg = "Add Atleast One  Item"
                no = 1
            }
        }
        else {

            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        const newRows = rows.filter(ele => ele.id != 100)
        const validate_form = validateForm()
        const grid_msg = ValidateGrid()

        if (grid_msg == "" && validate_form) {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    item_list: newRows,
                    deleteditem_list: deletedItemRows,
                    trans_id: formData[formField.transId],
                    bill_type: selBillType,
                    trade_of: selTradeOf,
                    nos: Number(total_Pcs),
                    weight: total_Weight,
                    vou_no: formData[formField.vouNo],
                    book_id: formData[formField.bookId],
                    party_id: formData[formField.partyId],
                    // trade_type:formData[formField.tradeType],
                    location_id: formData[formField.locationId],
                    pkt_type: selPktType == 'SNG' ? selPktType : '',
                    broker_id: formData[formField.brokerId],
                    challan_no: formData[formField.challanNo],
                    challan_date: formData[formField.challanDate],
                    remark: formData[formField.remark],
                    net_amount: net_Amount,
                    mkt_lotno:isUseMfgNoAsMktno?'0':"1",
                    login_userid: user.username,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
        else {
            toast.error(grid_msg, {
                "position": "top-center"

            })
        }
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            const newData = [...gridData, { id: 100, ...initialRow }].sort((a, b) => a.id - b.id)

            setRows(newData)
            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                if (detail?.itemData[0]?.RefTrnId && Number(detail?.itemData[0]?.RefTrnId) > 0)
                    setIsRefId(true)
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.vouNo]: detail?.itemData[0]?.Vou_No ?? "",
                    [formField.bookId]: detail?.itemData[0]?.Ac_Id ?? "",
                    [formField.brokerId]: detail?.itemData[0]?.Br_Id ?? "",
                    [formField.partyId]: detail?.itemData[0]?.Pac_Id ?? "",
                    [formField.locationId]: detail?.itemData[0]?.Lac_Id ?? "",
                    [formField.challanNo]: detail?.itemData[0]?.Chal_No ?? "",
                    [formField.challanDate]: detail?.itemData[0]?.Chal_Date ?? "",
                    [formField.remark]: detail?.itemData[0]?.Remark ?? "",
                    [formField.pcs]: detail?.itemData[0]?.Pcs ?? "",
                    [formField.weight]: detail?.itemData[0]?.Weight ?? "",

                })
            }
        }

    }, [detail, masterData])

    const funGetMasterLink = () => {
        if (selPktType == 'MIX')
            return naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster
        else
            return naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.returnEntry.returnEntryMaster
    }

    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }

    const handleAddRow = () => {
        let new_initialRow = initialRow
        if (modSettingParams && modSettingParams.Visibility) {

            if (Object.keys(modSettingParams.Visibility).length > 0) {
                //set default value to hidden grid column setting based
                const hiddenCol = Object.entries(modSettingParams.Visibility)
                    .filter(([key, value]) => value == false) // filter where value is true
                    .map(([key, value]) => {
                        return { [key]: modSettingParams.Value[key] }
                    });

                const result = hiddenCol.reduce((acc, current) => {
                    return { ...acc, ...current };
                }, {});

                if (result && Object.keys(result).length > 0)
                    new_initialRow = { ...initialRow, ...result }
            }

        }
        let newRowsId = rows.length + 1
        const newRow = { id: rows.length + 1, ...new_initialRow, }
        // setRows([...rows, newRow])

        if (rows.length == 0) {
            setRows([...rows, newRow
                , { id: 100, ...initialRow }
            ]
            )
        }
        else {
            newRowsId = rows.filter((ele) => ele.id != 100).length + 1
            const newData = [...rows, { id: newRowsId, ...new_initialRow, }]
            setRows(newData.sort((a, b) => a.id - b.id))
        }
        setTimeout(() => {
            const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
            if (gridScroller) {
                gridScroller.scrollLeft = 0; // Scroll to the left
            }
        }, 250)
        setTimeout(() => {
            const firstCell = gridContainerRef.current?.querySelector(
                `[data-id="${newRowsId}"] [data-field="id"]`
            );
            if (firstCell) {
                firstCell.focus();
            }
        }, 500);
    }

    const handleNewAcEntry = () => {
        funLoadMasterData(selTradeOf, selBillType,selPktType)
        // let redLink = naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.returnEntry.createReturnEntry
        // if (selPktType == 'MIX')
        //     redLink = naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry

        // dispatch(setRedirectLink(redLink))
        // navigate(linksUrl.master.account.createAccountMaster)
    }
    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        if (!parsed.isValid()) {
            toast.error("Invalid date format. Use DD/MM/YYYY", {
                position: "top-center",
                className: "toast-error"
            });
            return;
        }

        // ❌ Out of allowed range
        if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
            toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
                position: "top-center",
                className: "toast-error"
            });
            setFormData({ ...formData, [name]: null })
            return;
        }

        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");

        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });
    };

    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel}   Return Entry - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
                breadcrumbs={[selBillType == 'T' ? "Sale" : 'Purchase', entryLabel, "Return Entry", selPktType == 'SNG' ? "Single Packet" : selPktType]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" className="mb-3 w-full shadow p-3 bg-white">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <>
                                                            <Autocomplete
                                                                size="md"
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                menuTrigger={"input"}
                                                                isLoading={isLoadingData}
                                                                className="max-w-23"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                readonly={isNewEntry ? false : true}
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, '', item.name)
                                                                }
                                                                color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={formData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>
                                                            {item.name == formField.partyId ?
                                                                <Chip className="cursor-pointer bg-orange-300" color={"default"} onClick={handleNewAcEntry}>
                                                                    <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
                                                                </Chip>
                                                                : ""}
                                                            {/* {item.name == formField.partyId ?
                                                                <Chip className="cursor-pointer bg-slate-400" color={"default"} onClick={handleNewAcEntry}>New A/C.</Chip>
                                                                : ""} */}
                                                        </>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    minDate={minAllowedDate}
                                                                    maxDate={maxAllowedDate}
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name], "YYYY-MM-DD")
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => {
                                                                        setFormData((prev) => {
                                                                            return {
                                                                                ...prev,
                                                                                [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                            };
                                                                        });
                                                                    }}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: {
                                                                            size: "small", error: errors[item.name], helperText: errors[item.name],
                                                                            onBlur: (e) => handleDateBlur(e, item.name), required: true
                                                                        },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : item.type == ENUM_INPUT_TYPE.number ?
                                                        (
                                                            <NumberInput
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                minValue={0}
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                onChange={(e) => handleChange(e)}
                                                                onBlur={(e) => hanldeBlur("", e)}
                                                                readOnly={item.name == formField.vouNo ? true : false}
                                                                size={"md"}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></NumberInput>) : (

                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                onChange={(e) => handleChange(e)}
                                                                onBlur={(e) => hanldeBlur("", e)}
                                                                readOnly={item.name == formField.vouNo ? true : false}
                                                                size={"md"}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }

                            <div>
                                {
                                    isRefId ? "" :
                                        <div className="flex justify-between items-center">
                                            <Button size="sm" color="success" radius="sm" className="text-white cursor-default  text-xs bg-emerald-600" startContent={<FontAwesomeIcon color="white" icon={faGem} />}
                                                onPress={handleAddRow}>
                                                ADD ITEM
                                            </Button>
                                            <h6 className="text-sm text-green-700" >Total Items :
                                                {rows && rows.length > 0 ? rows.length - 1 : 0}</h6>
                                        </div>
                                }
                                {rows && rows?.length > 0 ? (
                                    <Box ref={gridContainerRef} sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            hideFooterPagination={true}
                                            hideFooter={true}
                                            columnHeaderHeight={30}
                                            rowHeight={45}
                                            disableColumnSorting={true}
                                            disableColumnMenu={true}
                                            getRowClassName={(params) => {
                                                if (params.id == 100) {
                                                    return 'sticky-row';  // Add custom class to the last row
                                                }
                                                return '';
                                            }}

                                            // getRowClassName={getRowClassName}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .sticky-row': {
                                                    position: 'sticky',
                                                    bottom: 0,
                                                    color: "#FFFFFF",
                                                    backgroundColor: '#424242f5',
                                                    zIndex: 10,
                                                },
                                                '& .sticky-row:hover': {
                                                    backgroundColor: "#424242f5"
                                                }
                                            }}
                                            columnVisibilityModel={{
                                                [RowsField.itemCode]: setColumnVisiblity(RowsField.itemCode),
                                                [RowsField.itemName]: setColumnVisiblity(RowsField.itemCode),
                                                [RowsField.lotNo]: setColumnVisiblity(RowsField.lotNo),
                                                [RowsField.pktNo]: setColumnVisiblity(RowsField.pktNo),
                                                [RowsField.shapeName]: setColumnVisiblity(RowsField.shapeCode),
                                                [RowsField.colorName]: setColumnVisiblity(RowsField.colorCode),
                                                [RowsField.purityName]: setColumnVisiblity(RowsField.purityCode),
                                                [RowsField.sizeName]: setColumnVisiblity(RowsField.sizeCode),
                                                [RowsField.lwRatio]: setColumnVisiblity(RowsField.lwRatio),
                                                [RowsField.reportNo]: setColumnVisiblity(RowsField.reportNo),
                                                [RowsField.lab]: setColumnVisiblity(RowsField.lab),
                                                [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),

                                            }}

                                        />
                                    </Box>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                <div className="flex  items-top gap-2 mt-7 ">
                                    {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? "" :
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Net Amount"
                                            placeholder="Net Amount"
                                            value={Number(net_Amount ?? 0)}
                                            className="max-w-25"
                                            variant="flat"
                                            color="success"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                    }
                                    {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Net Amount($)"
                                            placeholder="Net Amount($)"
                                            value={Number(net_AmountD ?? 0)}
                                            className="max-w-25"
                                            variant="flat"
                                            color="success"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">$</span>
                                                </div>
                                            }
                                        />
                                    }
                                </div>
                            </div>
                            <div className="justify-center flex gap-5 mt-5">
                                <Button
                                    color="primary"
                                    type="submit"
                                    size="md"
                                    variant="shadow"
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="md"
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </CardBody>
                    </form >
                </Card >
            </MainContainer>
        </div >
    )

}
export default CreateReturnEntry
